import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  box: {
    padding: theme.spacing(2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(8),
    },
  },
  mainArea: {
    position: 'relative',
    zIndex: '2',
  },
  sidebar: {
    position: 'absolute',
    marginTop: theme.spacing(-6),
    left: '100%',
    top: 272,
    width: 'calc(50vw - 500px)',
    boxSizing: 'border-box',
    padding: theme.spacing(4),
  },
}))
